export enum CrewMemberChangeAction {
  Added = 0,
  Updated = 1,
  Removed = 2,
}
